import { render, staticRenderFns } from "./guoneinew.vue?vue&type=template&id=4bf188be&scoped=true&"
import script from "./guoneinew.vue?vue&type=script&lang=js&"
export * from "./guoneinew.vue?vue&type=script&lang=js&"
import style0 from "./guoneinew.vue?vue&type=style&index=0&id=4bf188be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf188be",
  null
  
)

export default component.exports